// Module
var code = "<page-header title=\"'Roles'\" breadcrumbs=\"['Role management']\" reload=\"true\"> </page-header>\r\n\r\n<rbac-roles-datatable dataset=\"$ctrl.roles\"></rbac-roles-datatable>\r\n\r\n<div class=\"row\">\r\n  <access-viewer> </access-viewer>\r\n</div>\r\n";
// Exports
var _module_exports = code;;
var path = 'app/portainer/rbac/views/roles/roles.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;